module.exports = __webpack_public_path__ + "img/video.5f207fee.jpg";